import React, { useRef, useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import { isEmail, isEmpty, checkNested, getNested } from 'srcReact/helpers/validator'
import Modal from 'srcReact/components/common2/Modal'
import Button from 'srcReact/components/common2/Button'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

function ByFileUpload({ className, setEmails, setHasEmailErrors }) {
  const { t } = useTranslation()
  const allowedFileTypes = [
    'application/vnd.ms-excel',
    'text/csv',
    'text/x-csv',
    'application/csv',
    'application/x-csv',
    'text/x-comma-separated-values',
    'text/comma-separated-values'
  ]

  const fileInputRef = useRef(null)
  const [isCSVModalopen, setIsCSVModalopen] = useState(false)
  const [fileUploaded, setFileUploaded] = useState({
    errorCsv: false,
    uploaded: false,
    validEmailCount: 0,
    invalidEmailCount: 0,
    emails: []
  })

  const openCSVModal = () => {
    setIsCSVModalopen(true)
    setFileUploaded({
      ...fileUploaded,
      validEmailCount: 0,
      invalidEmailCount: 0,
      errorCsv: false,
      uploaded: false
    })
  }

  const closeCSVModal = () => {
    setIsCSVModalopen(false)
  }

  const openFileDialog = (e) => {
    e.stopPropagation()
    fileInputRef.current.click()
  }

  const selectFile = (e) => {
    if (e.target.files && e.target.files.length === 0) return
    if (!allowedFileTypes.includes(e.target.files[0].type)) {
      setFileUploaded({
        ...fileUploaded,
        uploaded: true,
        validEmailCount: 0,
        invalidEmailCount: 0,
        errorCsv: true
      })
      return
    }

    const input = e.target
    const reader = new FileReader()
    reader.onload = (e) => readerOnLoad(e, input.files[0])
    reader.readAsText(input.files[0])
  }

  const readerOnLoad = (e, file) => {
    if (e.target.result) {
      const strCsv = e.target.result
      let invalidEmailsCount = 0
      let validEmailsCount = 0
      const validEmails = []
      if (strCsv && strCsv.length > 0) {
        const emails = strCsv.split('\n')
        if (emails.length > 1) {
          for (let i = 1; i < emails.length; i++) {
            if (emails[i].trim().length === 0) continue
            const cleanEmail = emails[i].replace(/(\r\n|\n|\r)/gm, '')
            if (isEmail(cleanEmail)) {
              validEmailsCount++
              validEmails.push(cleanEmail)
            } else {
              invalidEmailsCount++
            }
          }
        }
        setFileUploaded({
          ...fileUploaded,
          uploaded: true,
          validEmailCount: validEmailsCount,
          invalidEmailCount: invalidEmailsCount,
          errorCsv: invalidEmailsCount.length > 0,
          emails: validEmails
        })
      }
    }
  }

  useEffect(() => {
    if (
      fileUploaded.uploaded &&
      !fileUploaded.errorCsv &&
      fileUploaded.emails.length > 0 &&
      fileUploaded.validEmailCount > 0 &&
      fileUploaded.invalidEmailCount === 0
    ) {
      setFileUploaded({
        ...fileUploaded,
        uploaded: true,
        validEmailCount: 0,
        invalidEmailCount: 0
      })
      setEmails(fileUploaded.emails)
      setHasEmailErrors(fileUploaded.errorCsv || fileUploaded.invalidEmailCount > 0)
      closeCSVModal()
    }
  }, [fileUploaded])

  const sendInvites = () => {}
  return (
    <div className={`${styles.inviteByFileUploadContainer} ${className}`}>
      <button className={styles.btnUpload} onClick={openCSVModal} aria-label={t('')}>
        <Icon name='download24Coloured' size='large32' />
      </button>
      <label className={styles.lblUpload}>{t('form.invite_form.csv.title')}</label>
      {!fileUploaded?.errorCsv &&
        fileUploaded?.emails?.length > 0 &&
        fileUploaded.invalidEmailCount === 0 &&
        !isCSVModalopen && (
          <p className={styles.fileCountText}>
            {t('invite_group_mixr.byEmail.fileUpload.countText', { count: fileUploaded.emails.length })}
          </p>
        )}
      <input ref={fileInputRef} type='file' className={styles.inputFile} onChange={selectFile} />
      {isCSVModalopen && (
        <Modal
          isOpen={isCSVModalopen}
          handleClose={closeCSVModal}
          title={t('invite_group_mixr.byEmail.fileUpload.title')}
          subTitle={t('invite_group_mixr.byEmail.fileUpload.subTitle')}>
          {fileUploaded?.uploaded ? (
            <div className={styles.errorWrapper}>
              {fileUploaded?.errorCsv ? (
                <React.Fragment>
                  <ErrorMessage text={t('invite_group_mixr.byEmail.fileUpload.error_file_type')} />
                  <Button
                    customStyle={styles.uploadAgain}
                    handleClick={openFileDialog}
                    text={t('invite_group_mixr.byEmail.fileUpload.upload_again')}
                  />
                </React.Fragment>
              ) : fileUploaded.invalidEmailCount > 0 ? (
                <React.Fragment>
                  <ErrorMessage
                    text={t('invite_group_mixr.byEmail.fileUpload.invalid_email', {
                      count: fileUploaded.invalidEmailCount
                    })}
                  />
                  <p>{t('form.invite_form.csv.invalid_email_info')}</p>
                  <Button
                    customStyle={styles.uploadAgain}
                    handleClick={openFileDialog}
                    text={t('invite_group_mixr.byEmail.fileUpload.upload_again')}
                  />
                </React.Fragment>
              ) : fileUploaded.emails.length === 0 ? (
                <React.Fragment>
                  <ErrorMessage text={t('invite_group_mixr.byEmail.fileUpload.no_email_found')} />
                  <Button
                    customStyle={styles.uploadAgain}
                    handleClick={openFileDialog}
                    text={t('invite_group_mixr.byEmail.fileUpload.upload_again')}
                  />
                </React.Fragment>
              ) : null}
            </div>
          ) : (
            <ul className={styles.steps}>
              <li className={styles.step}>
                <a
                  className='text-green'
                  href={`${config.webUrl}/assets-mixr/images-wp/import_template.csv`}
                  download='MixR Import Template.csv'
                  dangerouslySetInnerHTML={{ __html: t('invite_group_mixr.byEmail.fileUpload.step1') }}></a>
              </li>
              <li className={styles.step}>
                <span dangerouslySetInnerHTML={{ __html: t('invite_group_mixr.byEmail.fileUpload.step2') }}></span>
              </li>
              <li className={styles.step}>
                <span dangerouslySetInnerHTML={{ __html: t('invite_group_mixr.byEmail.fileUpload.step3') }}></span>
              </li>
              <li className={styles.step}>
                <button className={styles.uploadBtn} onClick={openFileDialog}>
                  <span dangerouslySetInnerHTML={{ __html: t('invite_group_mixr.byEmail.fileUpload.step4') }}></span>
                </button>
              </li>
            </ul>
          )}
        </Modal>
      )}
    </div>
  )
}

export default ByFileUpload
